import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')




// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const WebSearch = () => import('@/views/pages/WebSearch')
const WebSearch2 = () => import('@/views/pages/WebSearch2')
const Register = () => import('@/views/pages/Register')

// Dashboard
const Dashboard = () => import('@/views/Dashboard')

// Operations(營運單位模組)
const OperationsDepartment = ()     => import('@/views/Operations/Department')
const OperationsEnterpriseData = () => import('@/views/Operations/EnterpriseData')
const OperationsEnterpriseType = () => import('@/views/Operations/EnterpriseType')
const OperationsUsers = ()          => import('@/views/Operations/Users')

// Label(標籤作業模組)
const LabelStorehouseDataSet = ()   => import('@/views/Label/StorehouseDataSet')
const LabelProductionUnitSet = ()   => import('@/views/Label/ProductionUnitSet')
const LabelShapeDataSet = ()        => import('@/views/Label/ShapeDataSet')
const LabelStatusListSet = ()       => import('@/views/Label/StatusListSet')
const LabelOrder = ()               => import('@/views/Label/Order')
const LabelProduction = ()          => import('@/views/Label/Production')
const LabelStockIn = ()             => import('@/views/Label/StockIn')
const LabelProductionInvalid = ()   => import('@/views/Label/ProductionInvalid')
const LabelShip = ()                => import('@/views/Label/Ship')
const LabelReturnStockIn = ()       => import('@/views/Label/ReturnStockIn')
const LabelTransferOrder  = ()      => import('@/views/Label/TransferOrder')
const LabelSerialChange  = ()       => import('@/views/Label/SerialChange')
const LabelBatchChange  = ()        => import('@/views/Label/BatchChange')
const LabelStatus  = ()             => import('@/views/Label/Status')
const LabelSearch  = ()             => import('@/views/Label/Search')

const LabelInStockList  = ()        => import('@/views/Label/InStockList')
const LabelHistorySearch  = ()      => import('@/views/Label/HistorySearch')
const LabelInOutChangeList  = ()    => import('@/views/Label/InOutChangeList')
const LabelStockInAnalyze = ()      => import('@/views/Label/StockInAnalyze')
const LabelStockOutAnalyze = ()     => import('@/views/Label/StockOutAnalyze')
const LabelOrderNotOutStatus = ()   => import('@/views/Label/OrderNotOutStatus')
const LabelProductionInStatus = ()  => import('@/views/Label/ProductionInStatus')

// Full 全鏈路管理
const FullPublish = ()              => import('@/views/Full/Publish')
const FullPurchase = ()             => import('@/views/Full/Purchase')
const FullStatus = ()               => import('@/views/Full/Status')

// App(App內部管理)
const AppMessage = ()               => import('@/views/App/Message')
const AppVersion = ()               => import('@/views/App/Version')
const AppCameraSetting = ()         => import('@/views/App/CameraSetting')
const AppUserSearch = ()            => import('@/views/App/UserSearch')
const AppPhoneScanner = ()          => import('@/views/App/PhoneScanner')
const AppWebScanner = ()            => import('@/views/App/WebScanner')
const AppWeixinScanner = ()         => import('@/views/App/WeixinScanner')
const AppOfficialScanner = ()       => import('@/views/App/OfficialScanner')

// OperateLog(操作紀錄查詢)
const OperateLogCustomer  = ()      => import('@/views/OperateLog/Customer')
const OperateLogEnterprise  = ()    => import('@/views/OperateLog/Enterprise')
const OperateLogSystem  = ()        => import('@/views/OperateLog/System')
const OperateLogFullLinkReceiver = () => import('@/views/OperateLog/FullLinkReceiver')
const OperateLogFullLinkSend  = ()  => import('@/views/OperateLog/FullLinkSend')
const OperateLogService  = ()       => import('@/views/OperateLog/Service')

// Settings(系統參數及公司設定)
const SettingsOfficeData  = ()      => import('@/views/Settings/OfficeData')
const SettingMessage = ()           => import('@/views/Settings/Message')
const SettingEditMessage = ()       => import('@/views/Settings/EditMessage')
const SettingMyMessage = ()       => import('@/views/Settings/MyMessage')
const SettingMyMessageList = ()       => import('@/views/Settings/MyMessageList')
const SettingsSystemParams  = ()    => import('@/views/Settings/SystemParams')

// Users(用戶密碼權限設定)
const UsersUser  = ()               => import('@/views/Users/User')
const UsersRole  = ()               => import('@/views/Users/Role')
const UsersAssignUser  = ()         => import('@/views/Users/AssignUser')
const UsersAssignRole  = ()         => import('@/views/Users/AssignRole')
const UsersPwdChange  = ()          => import('@/views/Users/PwdChange')
const UsersEnterpriseManager  = ()  => import('@/views/Users/EnterpriseManager')

Vue.use(Router)

export default new Router({
  mode: 'hash', //'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      name: '主控版',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: '主控版',
          component: Dashboard
        },     
        {
          path: '/system/mymessage',
          name: '我的訊息',
          component: SettingMyMessage,         
        },
        {
          path: '/system/mymessagelist',
          name: '訊息清單',
          component: SettingMyMessageList,         
        },        
        {
          path: 'Operations',
          redirect: '/Operations/Department',
          name: '營運單位模組',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'Department',
              name: '部門資料設定',
              component: OperationsDepartment
            },
            {
              path: 'Users',
              name: '人員資料設定',
              component: OperationsUsers
            },
            {
              path: 'EnterpriseType',
              name: '企業用戶類別',
              component: OperationsEnterpriseType
            },
            {
              path: 'EnterpriseData',
              name: '企業用戶資料',
              component: OperationsEnterpriseData
            }             
          ]
        },
        {
          path: 'Label',
          redirect: '/Label/StorehouseDataSet',
          name: '標籤作業模組',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'StorehouseDataSet',
              name: '倉庫資料設定',
              component: LabelStorehouseDataSet
            },
            {
              path: 'ProductionUnitSet',
              name: '生產單位設定',
              component: LabelProductionUnitSet
            },
            {
              path: 'ShapeDataSet',
              name: '標籤款式資料設定',
              component: LabelShapeDataSet
            },
            {
              path: 'StatusListSet',
              name: '標籤狀態清單設定',
              component: LabelStatusListSet
            },
            {
              path: 'Order',
              name: '標籤訂購單',
              component: LabelOrder
            },
            {
              path: 'Production',
              name: '標籤生產單',
              component: LabelProduction
            },
            {
              path: 'StockIn',
              name: '標籤入庫單',
              component: LabelStockIn
            },
            {
              path: 'ProductionInvalid',
              name: '生產作廢單',
              component: LabelProductionInvalid
            },
            {
              path: 'Ship',
              name: '標籤出貨單',
              component: LabelShip
            },
            {
              path: 'ReturnStockIn',
              name: '標籤退貨入庫單',
              component: LabelReturnStockIn
            },
            {
              path: 'TransferOrder',
              name: '倉庫調撥單',
              component: LabelTransferOrder
            },
            {
              path: 'SerialChange',
              name: '標籤序號異動作業',
              component: LabelSerialChange
            },
            {
              path: 'BatchChange',
              name: '標籤批次異動作業',
              component: LabelBatchChange
            },
            {
              path: 'Status',
              name: '標籤狀態查詢',
              component: LabelStatus
            },
            {
              path: 'InStockList',
              name: '營運標籤庫存一覽表',
              component: LabelInStockList
            },
            {
              path: 'HistorySearch',
              name: '營運標籤歷程查詢',
              component: LabelHistorySearch
            },
            {
              path: 'InOutChangeList',
              name: '營運標籤進出異動表',
              component: LabelInOutChangeList
            },            
            {
              path: 'StockInAnalyze',
              name: '標籤入庫分析表',
              component: LabelStockInAnalyze
            },
            {
              path: 'StockOutAnalyze',
              name: '標籤出庫分析表',
              component: LabelStockOutAnalyze
            },
            {
              path: 'OrderNotOutStatus',
              name: '標籤訂購未出狀況表',
              component: LabelOrderNotOutStatus
            },
            {
              path: 'ProductionInStatus',
              name: '標籤生產入庫狀況表',
              component: LabelProductionInStatus
            },
            {
              path: 'Search',
              name: '標籤狀態查詢',
              component: LabelSearch
            },
          ]
        },
        {
          path: 'App',
          redirect: '/App/Message',
          name: 'App管理模組',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'Message',
              name: 'App訊息管理',
              component: AppMessage
            },
            {
              path: 'Version',
              name: 'App版本管理',
              component: AppVersion
            },
            {
              path: 'CameraSetting',
              name: 'App相機管理',
              component: AppCameraSetting
            },
            {
              path: 'UserSearch',
              name: '使用者編號查詢',
              component: AppUserSearch
            },
            {
              path: 'PhoneScanner',
              name: '手機掃描紀錄',
              component: AppPhoneScanner
            },
            {
              path: 'WebScanner',
              name: '網頁查詢紀錄',
              component: AppWebScanner
            },
            {
              path: 'WeixinScanner',
              name: '公眾號查詢紀錄',
              component: AppWeixinScanner
            },
            {
              path: 'OfficialScanner',
              name: '官網掃描紀錄',
              component: AppOfficialScanner
            }   
          ]
        },       
        {
          path: 'Full',
          redirect: '/Full/Publish',
          name: '全鏈路作業模組',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'Publish',
              name: '登載作業',
              component: FullPublish
            },
            {
              path: 'Purchase',
              name: '退貨作業',
              component: FullPurchase
            },
            {
              path: 'Status',
              name: '標籤狀態變更',
              component: FullStatus
            },           
            {
              path: 'FullLinkReceiver',
              name: '全鏈路接收紀錄',
              component: OperateLogFullLinkReceiver
            },
            {
              path: 'FullLinkSend',
              name: '全鏈路傳送紀錄',
              component: OperateLogFullLinkSend
            } 
          ]
        },       
        {
          path: 'OperateLog',
          redirect: '/OperateLog/Customer',
          name: '操作紀錄查詢',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'Customer',
              name: '營運單位操作者記錄',
              component: OperateLogCustomer
            },
            {
              path: 'Enterprise',
              name: '企業用戶操作者記錄',
              component: OperateLogEnterprise
            },
            {
              path: 'System',
              name: '系統錯誤記錄',
              component: OperateLogSystem
            },
            {
              path: 'Service',
              name: '服務運作狀態',
              component: OperateLogService
            },
          
            
            
          ]
        },
        {
          path: 'Settings',
          redirect: '/Settings/OfficeData',
          name: '系統參數及公司設定',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'OfficeData',
              name: '公司資料設定',
              component: SettingsOfficeData
            },
            {
              path: 'Message',
              name: '訊息設定',
              component: SettingMessage
            },
            {
              path: 'editmessage',
              name: '編輯訊息',
              component: SettingEditMessage             
            },      
            {
              path: 'SystemParams',
              name: '系統參數設定',
              component: SettingsSystemParams
            }               
          ]
        },
        {
          path: 'Users',
          redirect: '/Users/User',
          name: '用戶密碼權限設定',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'User',
              name: '營運用戶資料管理',
              component: UsersUser
            },
            {
              path: 'Role',
              name: '營運角色資料管理',
              component: UsersRole
            },
            {
              path: 'AssignUser',
              name: '角色用戶指派',
              component: UsersAssignUser
            },
            {
              path: 'AssignRole',
              name: '用戶角色指派',
              component: UsersAssignRole
            },
            {
              path: 'PwdChange',
              name: '營運用戶密碼修改',
              component: UsersPwdChange
            },
            {
              path: 'EnterpriseManager',
              name: '企業用戶資料管理',
              component: UsersEnterpriseManager
            }  
          ]
        }
      ]
    },



    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'websearch',
          name: 'WebSearch',
          component: WebSearch
        },
        {
          path: 'websearch2',
          name: 'WebSearch2',
          component: WebSearch2
        }
      ]
    }
  ]
}

